<section class="fdd-card fdd-card--flush fdd-map-chart-row">
  <div class="fdd-map-chart__col">
    <div class="fdd-map-chart__map-inner">
      <div class="fdd-index-list">
        <div class="fdd-card-title">{{ 'INDEX_TILE_MAP.INDEX' | translate }}</div>
        @for (opt of indexOptions; track opt.value) {
          <button
            type="button"
            class="fdd-index-item"
            [class.fdd-index-item--active]="selectedIndexValue === opt.value"
            (click)="onIndexClick(opt.value!)"
          >
            {{ indexLabel(opt) }}
          </button>
        }
      </div>
      <div class="fdd-map-wrap">
        <div class="fdd-map-title muted">
          {{
            'FIELD_DETAILS_V2.MAP_TITLE'
              | translate
                : { index: selectedIndexValue?.toUpperCase(), date: (selectedTimelineDate | date: 'dd.MM.yyyy') }
          }}
        </div>
        @if (indexTileUrl) {
          <div class="fdd-wms-opacity">
            <span class="fdd-wms-opacity__label muted">{{ 'FIELD_DETAILS_V2.WMS_LAYER_OPACITY' | translate }}</span>
            <p-slider
              [ngModel]="wmsOverlayOpacity"
              [min]="0.1"
              [max]="1"
              [step]="0.05"
              (ngModelChange)="onWmsOpacityChange($event)"
              class="fdd-wms-opacity__slider"
            />
          </div>
        }
        <div class="fdd-map-inner">
          @if (indexTileUrl) {
            <div class="fdd-map-scale">
              <span>1</span>
              <div class="fdd-map-scale__bar" [style.background]="mapIndexScaleBarGradient"></div>
              <span>0</span>
            </div>
          }
          <div class="fdd-map-canvas">
            <mfs-old-map
              [height]="'100%'"
              [center]="mapCenter"
              [zoom]="15"
              [polygonJson]="mapSeasonPolygonJson || undefined"
              [parentPolygonJson]="fieldPolygonJson || undefined"
              [polygonColor]="mapPolygonColorOnMiniMap"
              [indexRasterOverlayActive]="!!indexTileUrl"
              [indexTileUrl]="indexTileUrl"
              [indexTileOpacity]="wmsOverlayOpacity"
              [showIndexControl]="false"
              [drawingMode]="false"
              [showControls]="false"
              [isSplitControl]="false"
              [showCopyParentBtn]="false"
              [geometry]="''"
            ></mfs-old-map>
            @if (wmsTileLoading) {
              <div class="fdd-map-wms-loader" aria-busy="true">
                <app-loading [loading]="true"></app-loading>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fdd-map-chart__col fdd-map-chart__col--chart">
    <div class="fdd-card-title">
      {{ 'FIELD_DETAILS_V2.VEG_CHART' | translate: { index: selectedIndexValue?.toUpperCase() } }}
    </div>
    <div class="fdd-chart-box">
      @if (chartLoading) {
        <app-loading [loading]="true"></app-loading>
      } @else if (chartData) {
        <p-chart type="line" [data]="chartData" [options]="chartOptions" [style]="{ height: '220px', width: '100%' }"></p-chart>
      } @else {
        <div class="fdd-empty muted">{{ 'INDEX_TILE_MAP.CHART_MODAL.NO_DATA' | translate }}</div>
      }
    </div>
    <div class="fdd-phases">
      <div class="fdd-card-title fdd-phases__title">{{ 'FIELD_DETAILS_V2.CROP_PHASES' | translate }}</div>
      <div class="fdd-phases__row">
        @for (ph of cropPhases; track ph.id || $index) {
          <div class="fdd-phase-cell" [ngStyle]="phaseStyle($index)">
            <span class="fdd-phase-name">{{ ph | serverTranslate: 'names' }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</section>
